import { Component, Input } from '@angular/core';

@Component({
  selector: 'mayne-company-box',
  templateUrl: './company-box.component.html',
  styleUrls: ['./company-box.component.scss']
})
export class CompanyBoxComponent {

  @Input() text: string = ''; 
}
